<template>
  <nav aria-label="Progress">
    <ol class="flex items-center">
      <slot />
    </ol>
  </nav>
</template>
